module.exports = __webpack_public_path__ + "img/36a-config-usuarios-afastamentos.dbd3d342.png";